/* unplugin-vue-components disabled */
import {downloadFile} from 'stores/files'
import SourceType from './source-type.vue'

export default {
  components: {SourceType},
  props: {
    source: {type: Object, required: true},
  },
  computed: {
    can_click() {
      return ['url', 'link', 'file'].includes(this.source.type)
    },
  },
  methods: {
    async onSourceClick(){
      if (this.source.type === 'url') {
        window.open(this.source.url, '_blank')
        return
      }
      else if (this.source.type === 'file' ||this.source.type === 'link') {
        if (this.source.url) {
          window.open(this.source.url, '_blank')
          return
        }
        try {
          await downloadFile(this.source.file_id)
        }
        catch(err) {
          $utils.toasts.error(`Failed to download file ${this.source.name}: ${err}`)
        }
      }
      else if (this.source.url) {
        window.open(this.source.url, '_blank')
      }  
    }
  }
}
